import { render, staticRenderFns } from "./KeyPhysicalActuals.vue?vue&type=template&id=96c96c3a&scoped=true&"
import script from "./KeyPhysicalActuals.vue?vue&type=script&lang=ts&"
export * from "./KeyPhysicalActuals.vue?vue&type=script&lang=ts&"
import style0 from "./KeyPhysicalActuals.vue?vue&type=style&index=0&id=96c96c3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c96c3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VChip,VContainer,VDataTable,VIcon,VProgressCircular,VTextField,VTooltip})
